export function extractPlainText(node: any): string {
    if (node.type === 'text') {
        return node.text || '';
    }
    if (node.content && Array.isArray(node.content)) {
        return node.content
            .map(extractPlainText)
            .join(' ');
    }
    return '';
}
